import React from 'react';
import { IAuditoriaRoundTrippingResultado } from '../interfaces/IAuditoriaRoundTripping';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado: IAuditoriaRoundTrippingResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoRoundTripping: React.FC<Props> = ({ resultado, onSelecionar }) => {
  const temErro = resultado.totalErros > 0;
  const temAviso = resultado.totalAvisos > 0;
  const borderColor = temErro ? '#dc2626' : temAviso ? '#3b82f6' : '#22c55e';
  const badgeClass = temErro ? 'badge bg-danger' : temAviso ? 'badge bg-info text-dark' : 'badge bg-success';

  return (
    <div
      className='auditoria-card'
      style={{ borderLeft: `4px solid ${borderColor}`, cursor: 'pointer' }}
      onClick={() => onSelecionar('AUDITORIA_ROUND_TRIPPING')}
    >
      <div className='d-flex justify-content-between align-items-start'>
        <div>
          <h5 className='mb-1'>Detecção de Round-Tripping</h5>
          <p className='text-muted mb-2' style={{ fontSize: '0.85rem' }}>
            Circularidade financeira entre fornecedores/clientes via Fuzzy Matching Jaro-Winkler ≥ 90%.
            Candidatos fracos (histórico explica a coincidência) viram AVISO, não erro automático.
          </p>
        </div>
        <span className={badgeClass}>
          {temErro ? `${resultado.totalErros} ERRO(S)` : temAviso ? `${resultado.totalAvisos} AVISO(S)` : 'CONCILIADO'}
        </span>
      </div>

      <div className='row g-2 mt-1'>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: temErro ? '#fee2e2' : '#f0fdf4' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Passivo Total Estimado</div>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: temErro ? '#dc2626' : '#16a34a' }}>
              {formatCurrency(resultado.passivoTotalGeral)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Tributo (24% IRPJ+CSLL)</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temErro ? '#dc2626' : '#374151' }}>
              {formatCurrency(resultado.tributoPrincipalTotal)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Multa + Juros SELIC</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temErro ? '#dc2626' : '#374151' }}>
              {formatCurrency(resultado.multaQualificadaTotal + resultado.jurosSelicTotal)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Pares Detectados</div>
            <div style={{ fontSize: '1rem', fontWeight: 600 }}>
              {resultado.totalErros > 0 && <span className='text-danger'>{resultado.totalErros} Erro(s)</span>}
              {resultado.totalErros > 0 && resultado.totalAvisos > 0 && ' · '}
              {resultado.totalAvisos > 0 && <span className='text-primary'>{resultado.totalAvisos} Aviso(s)</span>}
              {resultado.totalErros === 0 && resultado.totalAvisos === 0 && <span className='text-success'>0</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditoriaResumoRoundTripping;
